// Translations for simple signature page
export const T = {
  en_GB: {
    invalidOrExpired: "Invalid or expired signature link",
    notSimpleSignature: "This is not a simple signature link",
    authNotAvailable: "Authentication not available for this link",
    failedToLoad: "Failed to load signature",
    pleaseProvideSignature: "Please provide your signature",
    failedToComplete: "Failed to complete signature",
    errorOccurred: "An error occurred while signing",
    signDocuments: "Sign Documents",
    documentsToSign: "Documents to Sign",
    documentsRequireSignature: "The following documents require your signature",
    viewPdf: "View PDF",
    yourSignature: "Your Signature",
    signInBox: "Please sign in the box below using your mouse, trackpad, or finger",
    clear: "Clear",
    signing: "Signing...",
    signDocumentsButton: "Sign Documents",
    signatureEvidence: "Signature Evidence",
    signatureStoredWith: "Your signature will be stored with verification data including:",
    dateAndTime: "Date and time of signing",
    authMethod: "Authentication method used (email or SMS)",
    contactVerified: "Contact information verified",
    digitalSignature: "Digital signature image",
    legallyBinding: "By signing, you agree that this is a legally binding electronic signature",
  },
  nb_NO: {
    invalidOrExpired: "Ugyldig eller utløpt signaturlenke",
    notSimpleSignature: "Dette er ikke en enkel signaturlenke",
    authNotAvailable: "Autentisering er ikke tilgjengelig for denne lenken",
    failedToLoad: "Kunne ikke laste signatur",
    pleaseProvideSignature: "Vennligst oppgi signaturen din",
    failedToComplete: "Kunne ikke fullføre signering",
    errorOccurred: "Det oppstod en feil under signeringen",
    signDocuments: "Signer dokumenter",
    documentsToSign: "Dokumenter å signere",
    documentsRequireSignature: "Følgende dokumenter krever din signatur",
    viewPdf: "Vis PDF",
    yourSignature: "Din signatur",
    signInBox: "Vennligst signer i boksen nedenfor med mus, styreflate eller finger",
    clear: "Tøm",
    signing: "Signerer...",
    signDocumentsButton: "Signer dokumenter",
    signatureEvidence: "Signaturbevis",
    signatureStoredWith: "Signaturen din vil bli lagret med verifiseringsdata inkludert:",
    dateAndTime: "Dato og tid for signering",
    authMethod: "Autentiseringsmetode brukt (e-post eller SMS)",
    contactVerified: "Kontaktinformasjon bekreftet",
    digitalSignature: "Digitalt signaturbilde",
    legallyBinding: "Ved å signere godtar du at dette er en juridisk bindende elektronisk signatur",
  },
} as const;
